<template src="../templates/normal_fcont_57.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'

import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import AppDownloadCardPrint from '../components/AppDownloadCardPrint'

import { Carousel,Slide } from 'uiv'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink'
export default {
  name: 'app',
  components: {
   LabelFunMessage,FuncSearchRecommendLink,Carousel,Slide,
   FuncSearchGalleryQR,AppDownloadCardPrint
  },
  data() {
    return {
      app_root: process.env.VUE_APP_ROOT
    }
  },
  methods: {
    trackGa4AppMultiRollDownloadEvent: function() {
      this.$gtag.event("app_download", {
        "app_name": "Multi Roll Print",
        "location_id": "article",
        "article_no": "57",
        "site_id": "gallery"
      })
    }
  },
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['57-1'],
    meta: [
      { name: 'description', content: this.$store.state.messages.messages['57-2']}
    ]};
  }
};
</script>
<style />


